import React from 'react'

import useResearcher from './useResearcher'
import ProjectRenewal from '../../../page/requestNewProject/projectRenewal/projectRenewal'
import useFolderAndTabStore from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import ResultOfConsider from '../../../page/resultOfConsider/resultOfConsider'
import NoticeAdditionalDocument from '../../../page/noticeAdditionalDocument/noticeAdditionalDocument'
import CertificateStampDocument from '../../../page/certificateStampDocument/certificateStampDocument'
import ResultOfConsiderPrevious from '../../../page/resultOfConsiderPrevious/resultOfConsiderPrevious'
import { menuTab } from '../../../../../../constants/constants'

type ResearcherViewType = ResearcherType & ReturnType<typeof useResearcher>
const ResearcherView: React.FC<ResearcherViewType> = (props) => {
    const { projectMode, callbackSaveComplete, initialData, isViewMode, submittedType, formValueRef, projectData } =
        props
    const folderAndTabStore = useFolderAndTabStore()
    const renderPage = () => {
        switch (folderAndTabStore?.tabSelected?.id) {
            case menuTab.tab21.id:
            case menuTab.tab25.id:
                return (
                    <ProjectRenewal
                        formMode={projectMode}
                        projectSubmittedTypeID={submittedType}
                        initialData={initialData}
                        isViewMode={isViewMode}
                        btnClose={isViewMode}
                        formValueRef={formValueRef}
                        onSaveComplete={callbackSaveComplete}
                        isEditAfterReview
                    />
                )
            case menuTab.tab22.id:
                return (
                    <>
                        <NoticeAdditionalDocument />
                    </>
                )
            case menuTab.tab23.id:
                return (
                    <>
                        <ResultOfConsider />
                    </>
                )
            case menuTab.tab24.id:
                return (
                    <>
                        <CertificateStampDocument />
                    </>
                )
            case menuTab.tab26.id:
                return (
                    <>
                        <ResultOfConsiderPrevious
                            projectID={projectData?.projectID ?? 0}
                            submittedID={projectData?.aroundSubmittedIDInfo.previousSubmittedID ?? 0}
                        />
                    </>
                )
            default:
                return <></>
        }
    }
    return renderPage()
}

export type ResearcherType = {
    projectMode: 'CREATE' | 'EDIT'
    callbackSaveComplete?: (resStatus: number, isDraft: boolean) => void
}
const Researcher: React.FC<ResearcherType> = (props) => {
    const researcher = useResearcher(props)
    return <ResearcherView {...props} {...researcher} />
}
export default Researcher
